export const CONTINUATION_TYPES = {
	DEFAULT: 'default',
	SECTION: 'section',
	SUBMIT: 'submit',
	PRODUCT_TICKETS: 'product_tickets',
	PRODUCT_TICKET_GROUPS: 'product_ticket_groups',
};

export const FIELD_TYPES = {
	CHECKBOX: 'Checkbox',
	CHECKBOXES: 'Checkboxes',
	DATETIME: 'DateTime',
	DATETIME_RANGE: 'DateTimeRange',
	EMAIL: 'Email',
	FILE_UPLOAD: 'FileUpload',
	LIKERT: 'LikertScale',
	LOCATION: 'Location',
	NUMBER: 'Number',
	PASSWORD: 'Password',
	PERCENTAGE: 'Percentage',
	RADIO: 'Radio',
	SECTION: 'SectionBreak',
	SELECT: 'Select',
	SOCIAL_MEDIA: 'SocialMedia',
	SWITCH: 'Switch',
	TEXT: 'Text',
	TEXTAREA: 'TextArea', // DEPRECATED
	TEXT_AREA: 'TextArea',
	TEXT_EDITOR: 'TextEditor',
	VIDEO: 'Video',
};

export const FIELD_SUB_TYPES = {
	EMAIL: 'email',
	FACEBOOK: 'facebook',
	LINKEDIN: 'linkedin',
	TWITTER: 'twitter',
};

export const FORM_TYPES = {
	APPLICATION: 'application',
	FORM: 'form',
	POLL: 'poll',
	POST_REGISTRATION: 'post-registration',
	PROFILE: 'profile',
	QUIZ: 'quiz',
};

export const PRIVACY_TYPES = {
	ONLY_ME: 0, // DEPRECATED, don't use!
	FACILITATORS: 20,
	CLASSMATES: 40,
	PUBLIC: 60,
};
